import React from 'react';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';
import ProgrammeProgress from './programme_progress';
import TopNavBar from '../user/top_nav_bar';
import ProgrammeProgressNotYetStarted from './programme_progress_not_yet_started';
import { programmeStartCalendarDay } from '../../services/my_day';
import { calendarDayFromJSDate } from '../../services/dates';
import { useCurrentProgrammeEnrollmentQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const SharedProgrammeProgressView = () => {
  // URL param is ignored, because there can only be one programme in progress at a given time.
  // const { sharedProgrammeId } = useParams();

  const { data: currentProgrammeEnrollment } =
    useCurrentProgrammeEnrollmentQuery();

  const programmeStartDate = programmeStartCalendarDay(
    currentProgrammeEnrollment,
  );

  const [searchParams] = useSearchParams();

  const todayOverride = searchParams.get('asOf');

  const today = todayOverride || calendarDayFromJSDate(new Date());

  if (!dayjs(today).isBefore(programmeStartDate, 'day')) {
    return <ProgrammeProgress />;
  }

  return (
    <div className="shared-programmes-view">
      <TopNavBar />
      <ProgrammeProgressNotYetStarted />
    </div>
  );
};

export default SharedProgrammeProgressView;
